var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrapper",style:({ height: '230px', width: '100%' }),attrs:{"id":"idg"}})}
var staticRenderFns = []

export { render, staticRenderFns }